export default __webpack_public_path__ + "static/media/concave-mirror.918b6dc8.jpg";